import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LargeButtonComponent } from '@kaseya-design-components';
import { Router } from '@angular/router';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import { LoginRecoveryOption } from '@pages/login-recovery-options/models/login-recovery-option.enum';
import { RecoverPasswordEmailSentComponent } from '@pages/login-recovery-options/components/recover-password-email-sent/recover-password-email-sent.component';
import { RecoverUsernameEmailSentComponent } from '@pages/login-recovery-options/components/recover-username-email-sent/recover-username-email-sent.component';
import { RecoverCompanyNameEmailSentComponent } from '@pages/login-recovery-options/components/recover-company-name-email-sent/recover-company-name-email-sent.component';

@Component({
  selector: 'itc-recover-email-sent',
  templateUrl: 'recover-email-sent.component.html',
  styleUrl: 'recover-email-sent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LargeButtonComponent,
    TranslatePipe,
    RecoverPasswordEmailSentComponent,
    RecoverUsernameEmailSentComponent,
    RecoverCompanyNameEmailSentComponent,
  ],
})
export class RecoverEmailSentComponent implements OnDestroy {
  private readonly router = inject(Router);
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly loginRecoveryOption = this.loginRecoveryFacade.recoveryOption;
  readonly LoginRecoveryOption = LoginRecoveryOption;

  backToLogin(): void {
    this.router.navigateByUrl(ApplicationPath.Login);
  }

  ngOnDestroy(): void {
    this.loginRecoveryFacade.clearState();
  }
}
